import Vue from 'vue'
import { Button, Popup, Notify, Toast, Tab, Tabs, CountDown, Step, Steps, ImagePreview, List } from 'vant'

Vue.use(Button)

Vue.use(Popup)

Vue.use(Notify)

Vue.use(Toast)

Vue.use(Tab)
Vue.use(Tabs)

Vue.use(CountDown)

Vue.use(Step)
Vue.use(Steps)

Vue.use(ImagePreview)

Vue.use(List)
